import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { GeckoFields, GeckoBtn, GECKO_CONSTS } from 'ui';

import './index.scss';
import TemplateTags, { formatFunctions } from 'services/template-tags';

const formatFormatOptions = (obj, type, keyPrefix = '') => {
  if (!type) {
    return [];
  }
  const formats = formatFunctions[type];
  return Object.keys(formats).map((key) => {
    return {
      label: key,
      value: `${type}.${key}`,
    };
  });
};

const formatValueOptions = (options, keyPrefix = '') => {
  return options
    .map((option) => {
      if (!option.value) {
        return null;
      }
      if (option.type === 'group') {
        return {
          label: option.label,
          options: formatValueOptions(
            option.value,
            `${keyPrefix}${option.tag}.`
          ),
        };
      } else {
        return {
          label: option.label,
          type: option.type,
          value: `${keyPrefix}${option.tag}`,
        };
      }
    })
    .filter((opt) => opt !== null);
};

class TagBuilder extends Component {
  static propTypes = {
    context: PropTypes.array,
    onInsert: PropTypes.func,
  };

  static defaultProps = {
    context: [],
    onInsert: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps) {
    if (prevProps.context !== this.props.context) {
      const value = formatValueOptions(this.props.context)
        .reduce((flattened, opt) => {
          if (opt.options) {
            return flattened.concat(opt.options);
          }
          return flattened.concat(opt);
        }, [])
        .find((opt) => opt.value === this.state.value);
      if (!value) {
        this.setState({ value: null });
      }
      const tag = this.generateTag();
      const preview = TemplateTags(tag, this.props.context);
      this.setState({ tag, preview });
    }
  }

  isListFormat() {
    const listFormatKeys = Object.keys(formatFunctions.list).map(
      (key) => `list.${key}`
    );
    return listFormatKeys.indexOf(this.state.format) !== -1;
  }

  isMultiLine() {
    return this.state.selectedType === 'multiline_text';
  }

  onValueSelect(selected) {
    if (selected) {
      const newFormats = formatFormatOptions(formatFunctions, selected.type);
      this.setState(
        {
          formatOptions: newFormats,
          format: null,
          selectedType: selected.type,
        },
        () => {
          if (selected.type === 'date_time') {
            this.setState({ format: 'date_time.Long' });
          }
          if (selected.type === 'link') {
            this.setState({ format: 'link.Link' });
          }
          return this.onChange('value', selected.value);
        }
      );
    }
    return this.onChange('value', null);
  }

  fields() {
    return [
      {
        label: 'Value',
        required: true,
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        key: 'value',
        options: formatValueOptions(this.props.context),
        config: {
          onChange: this.onValueSelect.bind(this),
        },
      },
      {
        label: 'Format',
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        key: 'format',
        options: this.state.formatOptions,
      },
      {
        label: 'Preview',
        type: GECKO_CONSTS.FIELD_TYPE_TEXTAREA,
        autoResize: true,
        key: 'preview',
        disabledWhen: () => true,
        hideWhen: () => !this.isListFormat() && !this.isMultiLine(),
      },
      {
        label: 'Preview',
        type: GECKO_CONSTS.FIELD_TYPE_TEXT,
        key: 'preview',
        disabledWhen: () => true,
        hideWhen: () => this.isListFormat() || this.isMultiLine(),
      },
      {
        label: 'Tag',
        type: GECKO_CONSTS.FIELD_TYPE_TEXT,
        key: 'tag',
        disabledWhen: () => true,
      },
    ];
  }

  generateTag() {
    if (!this.state.value) {
      return '';
    }
    const valuePart = `{{${this.state.value}}}`;
    if (!this.state.format) {
      return valuePart;
    }
    return `{{#format.${this.state.format}}}${valuePart}{{/format.${this.state.format}}}`;
  }

  onChange(key, value) {
    this.setState({ [key]: value }, () => {
      const tag = this.generateTag();
      const preview = TemplateTags(tag, this.props.context);
      this.setState({ tag, preview });
    });
  }

  render() {
    return (
      <div className="TagBuilder">
        <div className="row">
          <GeckoFields
            fields={this.fields()}
            values={this.state}
            handler={this.onChange.bind(this)}
          />
        </div>
        <GeckoBtn
          name="Insert"
          handler={() => this.props.onInsert(this.state.tag)}
          disabledWhen={() => !this.state.value}
        />
      </div>
    );
  }
}

export default TagBuilder;
